import api from './axios';

/**
 * Получить шаблон рецензии для конкретного фестшрифта.
 *
 * backend: POST /templates/publishing/{festschriftId}
 */
export const getTemplate = async (festschriftId) => {
  try {
    const response = await api.post(`/templates/publishing/${festschriftId}`);
    const blocks = response.data.blocks;
    const template_id = response.data.id;

    const blocksObjects = blocks.map((block, index) => ({
      ...block,
      // backwards compat: old templates have no "required"
      required: block?.required ?? true,
      // добавляем id, если его нет, чтобы React-формы не падали
      id: block.id || `block_${index + 1}`,
    }));

    return {
      blocks: blocksObjects,
      id: template_id,
    };
  } catch (error) {
    console.error('getTemplate failed', error);
    throw error;
  }
};

/**
 * Сохранить шаблон рецензии для фестшрифта.
 *
 * backend: PUT /templates/publishing/{festschriftId}
 */
export const saveTemplate = async (festschriftId, template) => {
  try {
    const response = await api.put(`/templates/publishing/${festschriftId}`, template);
    return response.data;
  } catch (error) {
    console.error('saveTemplate failed', error);
    throw error;
  }
};
